module.exports = __webpack_public_path__ + "media/images/404-e4ce9432d9dc4e1e47362ccc0cb003e3.svg";